<template>
  <div class="row">
    <div class="col">
      <router-link
        to="/marketing/price-comparison"
        class="btn btn-secondary btn-no-r"
      >
        <span><BaseIcon name="wallet-money" /> {{ $t("menu.priceLogs") }}</span>
      </router-link>
      <router-link
        to="/marketing/price-comparison/data"
        class="btn btn-no-l btn-primary"
      >
        <span
          ><BaseIcon name="info-circle" />
          {{ $t("menu.priceComparison") }}</span
        >
      </router-link>
    </div>
    <div class="col-12 mt-3">
      <div class="nature-white-box">
        <div class="white-box-top"></div>
        <div class="row px-2">
          <TopBar
            v-model:selectAll="selectAll"
            v-model:line-options="lineOptions"
            v-model:rows="tableRows"
            v-model:items="items"
            v-model:selectedLineOption="selectedLineOption"
            v-model:selectedItems="selectedItems"
            :show-add="false"
            :path="type"
            :show-languages="false"
            :show-currencies="false"
            :export-url="getExportUrl()"
            :async-export="true"
            @export-request="requestExport"
          />
          <DynamicTable
            :key="tableKey"
            v-model:rows="tableRows"
            v-model:items="items"
            v-model:select-all="selectAll"
            :show-pin="false"
            v-on:selected="(e) => (selectedItems = e)"
            :type="type"
            v-on:loadMore="loadMore"
            :load-in-process="loadInProcess"
            :fix-height="true"
          />
        </div>
      </div>
    </div>
    <div ref="exportModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Export requested</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            {{ exportMessage }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";
import DynamicTable from "@/components/lists/DynamicTable.vue";
import TopBar from "@/components/lists/TopBar.vue";
import { useStore } from "vuex";
import BaseIcon from "../../components/icons/BaseIcon.vue";
const bootstrap = require("bootstrap");

export default {
  name: "PriceComparison",
  components: {
    BaseIcon,
    DynamicTable,
    TopBar,
  },
  data() {
    return {
      store: useStore(),
      type: "price-comparison",
      items: [],
      total: 0,
      page: 1,
      loadInProcess: false,
      filtersTimeOut: null,
      selectAll: false,
      selectedItems: [],
      selectedLineOption: 0,
      lineOptions: [],
      tableRows: [],
      currencies: [],
      comparisonWebshops: [],
      tableKey: 0,
      categories: [],
      partners: [],
      characteristics: [],
      filterLoaded: false,
      exportModal: null,
      exportMessage: "Your export will be sent by email when it is ready.",
    };
  },
  computed: {
    q() {
      return this.store.state.topBar.q;
    },
    filterPage() {
      return this.store.state.filterPage;
    },
    filters() {
      return this.store.state.filters?.price_comparison;
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    q() {
      if (this.filtersTimeOut !== null) {
        clearTimeout(this.filtersTimeOut);
      }
      this.filtersTimeOut = setTimeout(() => {
        this.filtersTimeOut = null;
        this.items = undefined;
        this.page = 1;
        this.loadData();
      }, 450);
    },
    filters: {
      deep: true,
      handler() {
        if (this.filterPage !== "price_comparison") {
          return;
        }
        if (this.filtersTimeOut !== null) {
          clearTimeout(this.filtersTimeOut);
        }
        this.filtersTimeOut = setTimeout(() => {
          this.filtersTimeOut = null;
          this.items = undefined;
          this.page = 1;
          this.loadData();
        }, 450);
      },
    },
  },
  methods: {
    requestExport(type) {
      this.exportMessage =
        "Generating your export. It will be sent by email when it is ready.";
      if (!this.exportModal) {
        this.exportModal = new bootstrap.Modal(this.$refs.exportModal);
      }
      this.exportModal.show();

      http
        .fetch(this.getExportUrl().replace("{type}", type))
        .then((response) => {
          this.exportMessage =
            response.message ||
            "Your export will be sent by email when it is ready.";
        })
        .catch(() => {
          this.exportMessage =
            "The export could not be started. Please try again.";
        });
    },
    getExportUrl() {
      let url = `/price-comparison/export/{type}?page=1&per_page=10000`;

      if (this.q) {
        url += `&q=${encodeURIComponent(this.q)}`;
      }

      if (
        this.filters &&
        Object.keys(this.filters).length > 0 &&
        this.filterPage === "price_comparison"
      ) {
        for (const filter in this.filters) {
          if (Array.isArray(this.filters[filter].value)) {
            for (const value of this.filters[filter].value) {
              url += `&filter[${filter}][]=${encodeURIComponent(value)}`;
            }
          } else {
            url += `&filter[${filter}]=${encodeURIComponent(
              this.filters[filter].value
            )}`;
          }
        }
      }

      return url;
    },
    loadData() {
      if (this.categories.length === 0) {
        http.fetch(`/products/products/categories?language=en`).then((data) => {
          this.categories = [];
          this.setUpCategories({ categories: data.data });
        });
      }
      if (!this.filterLoaded && this.partners.length === 0) {
        http.fetch("/crm/partners/has-price").then((data) => {
          this.partners = data;
          if (this.characteristics.length > 0) {
            this.setFilterOptions();
          }
        });
      }
      if (this.filterPage !== "price_comparison") {
        this.$store.commit("setFilterOptions", []);

        http
          .fetch(
            "/products/products/characteristics?language=en&show_in_filter=1"
          )
          .then((data) => {
            this.characteristics = data;
            if (this.partners.length > 0) {
              this.setFilterOptions();
            }
          });
      }

      this.loadInProcess = true;
      let url = `/price-comparison/comparison-data?page=${
        this.page
      }&per_page=50&q=${this.q ? this.q : ""}`;

      if (
        this.filters &&
        Object.keys(this.filters).length > 0 &&
        this.filterPage === "price_comparison"
      ) {
        for (const filter in this.filters) {
          if (Array.isArray(this.filters[filter].value)) {
            for (const value of this.filters[filter].value) {
              url += `&filter[${filter}][]=${value}`;
            }
          } else {
            url += `&filter[${filter}]=${this.filters[filter].value}`;
          }
        }
      }

      http
        .fetch(url)
        .then((response) => {
          this.currencies = response.currencies || [];
          this.comparisonWebshops = response.comparison_webshops || [];
          const newItems = response.data;
          if (this.page === 1) {
            this.updateTableRows();

            this.items = newItems;
            this.tableKey++;
          } else {
            this.items = [...this.items, ...newItems];
          }
          this.total = response.total;
          this.loadInProcess = false;
        })
        .catch(() => {
          this.loadInProcess = false;
        });
    },
    updateTableRows() {
      const rows = [
        {
          name: "Product Name",
          key: "product_name",
          type: "string",
          show: true,
          textLeft: true,
          editable: false,
        },
        {
          name: "SKU",
          key: "sku",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "EAN",
          key: "ean",
          type: "string",
          show: true,
          editable: false,
        },
      ];

      // Add columns for our prices in different currencies
      this.currencies.forEach((currency) => {
        rows.push({
          name: `Price (${currency})`,
          key: `price_${currency}`,
          type: "price",
          show: true,
          editable: false,
        });
      });

      // Add columns for comparison prices
      this.comparisonWebshops.forEach((webshop) => {
        rows.push({
          name: webshop.name,
          key: `price_comparison_${webshop.id}`,
          type: "price",
          show: true,
          editable: false,
        });
      });

      this.tableRows = rows;
    },
    loadMore() {
      if (this.items.length < this.total) {
        this.page++;
        this.loadData();
      }
    },
    setUpCategories(data, str = "") {
      if (data.categories !== undefined) {
        for (const category of data.categories) {
          this.setUpCategories(
            category,
            data.name !== undefined ? `${str}${data.name} - ` : ""
          );
        }
      } else {
        this.categories.push({
          name: `${str}${data.name}`,
          top: data.name,
          sub: str,
          id: data.id,
        });
      }
    },
    setFilterOptions() {
      let filterOptions = [];
      this.$store.commit("setFilterPage", "price_comparison");

      filterOptions.push({
        name: "Categories",
        type: "string",
        key: "categories",
        value: {},
        values: this.categories,
        valueName: "name",
      });

      filterOptions.push({
        name: "Partners",
        type: "string",
        key: "partners",
        value: {},
        values: this.partners,
        valueName: "name",
      });

      for (const obj of this.characteristics) {
        let max =
          obj.characteristics_values_max_val_double !== null
            ? obj.characteristics_values_max_val_double
            : obj.characteristics_values_max_val_int;
        filterOptions.push({
          name: obj.name,
          type: obj.type,
          key: "characteristics[" + obj.id + "]",
          value: obj.type === "number" ? [0, max] : {},
          max: max,
          values: obj?.characteristics_values,
          prefix: obj?.prefix,
          postfix: obj?.postfix,
        });
      }

      this.$store.commit("setFilterOptions", filterOptions);
      this.$store.commit("setFilterOptionsStock", false);
      this.$store.commit("setFilterOptionsPrice", false);
      this.filterLoaded = true;
    },
  },
};
</script>
